import { render } from "./App.vue?vue&type=template&id=cfc2dea8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cfc2dea8&lang=stylus"
script.render = render

export default script